import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class ReferralPromptClickedEventTracking extends BaseEventTracking {
  static eventName: string = SegmentEvent.FREEWILL_REFERRAL_PROMPT_CLICKED;

  ctaLocation: string;

  constructor(ctaLocation: string) {
    super();

    this.ctaLocation = ctaLocation;
  }
}
